export function registerAcceptInterceptor(instance) {
    instance.interceptors.request.use(
        (config) => {
            switch (config.headers.getAccept()) {
                case 'application/pdf':
                case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                case 'text/csv':
                    config.responseType = 'blob';
                    break;
            }

            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );
}
